import { ROLE_MAP } from "./trainingData";

export default function RoleMapSection() {
  return (
    <section id="rolemap" className="max-w-[1200px] mx-auto px-4 py-5 pb-12 sm:px-6 md:px-10 sm:pb-22">
      <div className="max-w-[760px] mb-4">
        <div
          className="font-mono text-[12px] text-[#71717a] mb-[18px]"
          style={{ letterSpacing: "0.18em" }}
        >
          05 — ROLE MAP
        </div>
        <h2
          className="font-bold text-white mb-[18px]"
          style={{
            fontSize: "clamp(30px, 3.7vw, 46px)",
            lineHeight: 1.06,
            letterSpacing: "-0.03em",
          }}
        >
          Five career lanes, and where each level puts you
        </h2>
        <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#a1a1aa]">
          Cybersecurity is not one job. Every lane below starts with the same
          Foundation levels, then splits. Read across a row to see the next
          ten years of a career — and which level unlocks each step.
        </p>
      </div>

      {/* Desktop table view */}
      <div className="hidden lg:block border border-[#27272a] rounded-[14px] bg-[#09090b] px-6 pb-6">
        <div
          className="grid grid-cols-[168px_1fr_26px_1fr_26px_1fr] font-mono text-[10px] text-[#52525b] py-4 pb-2.5"
          style={{ letterSpacing: "0.14em" }}
        >
          <div>LANE</div>
          <div>ENTRY · 0–2 YEARS</div>
          <div />
          <div>MID · 2–5 YEARS</div>
          <div />
          <div>SENIOR · 5+ YEARS</div>
        </div>

        {ROLE_MAP.map((lane, li) => (
          <div
            key={li}
            className="grid grid-cols-[168px_1fr_26px_1fr_26px_1fr] items-stretch border-t border-[#18181b]"
          >
            <div className="flex items-center gap-[9px] py-[22px] pr-[18px]">
              <span
                className="w-[9px] h-[9px] rounded-[2px] flex-none"
                style={{ background: lane.color }}
              />
              <span className="font-mono text-[11px] text-[#d4d4d8] tracking-[0.12em]">
                {lane.lane}
              </span>
            </div>
            {[lane.entry, lane.mid, lane.senior].map((card, ci) => (
              <>
                {ci > 0 && (
                  <div
                    key={`arrow-${ci}`}
                    className="flex items-center justify-center font-mono text-[13px] text-[#3f3f46]"
                  >
                    →
                  </div>
                )}
                <div
                  key={`${li}-${ci}`}
                  className="border border-[#3f3f46] rounded-[10px] bg-black p-4 my-3.5"
                >
                  <div className="text-[15px] font-semibold tracking-[-0.01em] mb-[7px]">
                    {card.title}
                  </div>
                  <div className="font-mono text-[10px] text-[#a3e635] mb-2 tracking-[0.1em]">
                    {card.levels}
                  </div>
                  <div className="text-[12.5px] text-[#71717a] leading-snug">
                    {card.desc}
                  </div>
                </div>
              </>
            ))}
          </div>
        ))}
      </div>

      {/* Mobile stacked card view */}
      <div className="md:hidden border border-[#27272a] rounded-[14px] bg-[#09090b] p-4">
        {ROLE_MAP.map((lane, li) => (
          <div key={li} className={`${li > 0 ? "border-t border-[#18181b] mt-4 pt-4" : ""}`}>
            <div className="flex items-center gap-[9px] mb-3">
              <span
                className="w-[9px] h-[9px] rounded-[2px] flex-none"
                style={{ background: lane.color }}
              />
              <span className="font-mono text-[11px] text-[#d4d4d8] tracking-[0.12em]">
                {lane.lane}
              </span>
            </div>
            <div className="grid gap-2.5">
              {[lane.entry, lane.mid, lane.senior].map((card, ci) => (
                <div
                  key={ci}
                  className="border border-[#3f3f46] rounded-[10px] bg-black p-3.5"
                >
                  <div className="font-mono text-[10px] text-[#a3e635] mb-1 tracking-[0.1em]">
                    {card.levels}
                  </div>
                  <div className="text-[14px] font-semibold tracking-[-0.01em] mb-1">
                    {card.title}
                  </div>
                  <div className="text-[12px] text-[#71717a] leading-snug">
                    {card.desc}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-6 mt-[18px] font-mono text-[11px] text-[#52525b] leading-[1.8]">
        <span>NO LANE IS REACHABLE WITHOUT LEVELS 1–3</span>
        <span>MOST STUDENTS TAKE THEIR FIRST JOB AFTER LEVEL 6</span>
        <span>LANES CROSS: L8 AUTOMATION LIFTS ALL FOUR</span>
      </div>
    </section>
  );
}
